import React, { useContext, useState } from "react";
import MenuContext from "../../contexts/menu";
import {
  Container,
  Overlay,
  SelectContainer
} from "./styles"
import MobileAside from "../aside/mobile";
import Select from "../select";
import { CustumerContext } from "../../contexts/custumer";
import Options from "../select/options";


interface IProps {
  children: React.ReactElement
}


const Content: React.FC<IProps> = ({ children }) => {
  const { isOpen, toggleMenu } = useContext(MenuContext);
  const isMenuOpen = isOpen;
  const { current_custumer_description, selectCurrentCustumer, custumer_list, deleteList } = useContext(CustumerContext);
   const [showOptions, setShowOptions] = useState<boolean>(false)

  return (
    <>
     {showOptions && <Options close={() => setShowOptions(false)} selectOption={selectCurrentCustumer} itens={custumer_list} sortAlphabetically />}
    <Container id="content">
      <Overlay onClick={toggleMenu} $open={isOpen} />
      <MobileAside  />
       {/* <SelectContainer>
        <p className="text-[.85rem] font-bold text-gray-700 mb-2 px-1">Cliente</p>
        <Select
            noBorder={true}
            noBackgroundColor={true}
            onOpenOptions={() => setShowOptions(true)}
            label={current_custumer_description}
          />
          </SelectContainer> */}
      {children}
    </Container>
    </>
  )
}

export default Content;